import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SitesService } from 'src/app/admin/1.tv/sites/sites.service';
import { Order } from 'src/app/app.models';
import { StripeResponseService } from 'src/app/services/stripe-response.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-order-details-dialog',
  templateUrl: './order-details-dialog.component.html',
  styleUrls: ['./order-details-dialog.component.scss']
})
export class OrderDetailsDialogComponent implements OnInit {
  public deliveryAddress = {
    firstName: 'Kelvin',
    lastName: 'Beech',
    middleName: '',
    company: '',
    email: 'kelvin.beech@admir.tv',
    phone: '+447973737097',
    country: 'Wales',
    city: 'MyCity',
    place: 'Brooklyn',
    postalCode: 'NP13',
    address: '999 Any Street',
    id: 1
  };

  currency: string;
  public companyId: string;
  public siteId: string;
  symbol: string;
  euro: string;
  public discount = 0;


  constructor(
    protected stripeResponseService: StripeResponseService,
    protected sitesService: SitesService,
    public dialogRef: MatDialogRef<OrderDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public order: Order) {
    this.companyId = stripeResponseService.companyId;
    this.siteId = stripeResponseService.siteId;

    if (stripeResponseService.currentLoggedInUser.companyDiscounts === undefined) {
      this.discount = 0;
    } else {
      const entriesToArray = Object.entries(stripeResponseService.currentLoggedInUser.companyDiscounts);
      const ret = this.checkForDiscountForUser(this.companyId, entriesToArray);

      if (ret.length === 1) {
        const companyId = ret[0][0];
        const discount = ret[0][1];

        this.discount = discount;

      } else {
        this.discount = 0;
      }

    }


  }


  ngOnInit(): void {


    this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
      .subscribe((sites) => {

        this.currency = (sites[0].cashCurrency !== undefined) ? sites[0].cashCurrency : 'GBP';

        if (this.currency === 'EUR') {
          this.symbol = '';
          this.euro = '€';
        } else {
          this.symbol = 'symbol';
          this.euro = '';
        }
      });
  }

  checkForDiscountForUser(cId: string, discounts: any) {

    discounts = discounts.filter((discount: any) => {

      if (discount[0] === cId) {
        return true;
      } else {
        return false;
      }
    });

    return discounts;
  }
}
